const addressValidationRegex =
  /^\d+[A-Za-z0-9-/]*\s+(?:[NSEW]\.?\s+)?[A-Za-z0-9.\-']+\s+[A-Za-z0-9.\-']+(?:\s+(?:St|Street|Ave|Avenue|Rd|Road|Blvd|Boulevard|Ln|Lane|Dr|Drive|Ct|Court|Pl|Place|Way|Sq|Square))?(?:\s+[NSEW]{1,2})?(?:\s+(?:Apt|Apartment|Unit|Suite|Ste|#)\s*\w+)?(?:(?:,\s*|\s+)[A-Za-z][A-Za-z\s.\-']*)?(?:(?:,\s*|\s+)(?:AL|AK|AZ|AR|CA|CO|CT|DE|FL|GA|HI|ID|IL|IN|IA|KS|KY|LA|ME|MD|MA|MI|MN|MS|MO|MT|NE|NV|NH|NJ|NM|NY|NC|ND|OH|OK|OR|PA|RI|SC|SD|TN|TX|UT|VT|VA|WA|WV|WI|WY))?(?:(?:,\s*|\s+)\d{5}(?:-\d{4})?)?(?:(?:,\s*|\s+)(?:United\s+States|USA|US|AMERICA|America))?$/i;

export const validateUSAddress = (address: string) => addressValidationRegex.test(address.replace(/,/g, '').trim());
export const validateURL = (value: string) => {
  try {
    const url = new URL(value);
    return url.protocol === 'https:';
  } catch {
    return false;
  }
};
